export default __webpack_public_path__ + "static/media/fixed-carbon-icon.c11addf9.svg";